/**
 * What the portfolio page's Analyst rail sends with every turn.
 *
 * A *descriptor*, never data: only `deal_name` identifies anything, and the
 * server re-reads that deal's tables, scoped to the caller's deal rooms, at
 * turn time. The tab, the view, the plat and the open cell say where on the
 * page the question was asked, so "this house" and "this figure" mean what is
 * on screen.
 */

export interface PortfolioDataContext {
	kind: "portfolio_data_run";
	deal_name: string;
	tab: string | null;
	view: string | null;
	plat_id: string | null;
	house_id: string | null;
	line_item: string | null;
}

export interface PortfolioDataContextInput {
	dealName: string;
	tab?: string | null;
	view?: string | null;
	platId?: string | null;
	houseId?: string | null;
	lineItem?: string | null;
}

export function buildPortfolioDataContext({
	dealName,
	tab = null,
	view = null,
	platId = null,
	houseId = null,
	lineItem = null,
}: PortfolioDataContextInput): PortfolioDataContext {
	return {
		kind: "portfolio_data_run",
		deal_name: dealName,
		tab,
		view: tab === "tables" ? view : null,
		plat_id: platId,
		house_id: houseId,
		line_item: houseId ? lineItem : null,
	};
}

/** The rail's chip: what "this" means in every question sent. */
export function portfolioChipLabel({
	platName,
	houseId,
	label,
}: {
	platName: string | null;
	houseId: string | null;
	label: string | null;
}): string {
	if (houseId && label) return `${houseId} · ${label}`;
	if (platName) return platName;
	return "All plats";
}
